import { InvoiceRepository } from "../repositories/InvoiceRepository";
import { ZohoInvoiceDetailsEntity } from "../entities/InvoiceListItemEntity";

export class GetZohoInvoiceDetailsUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(zohoInvoiceId: string): Promise<ZohoInvoiceDetailsEntity> {
    // Validate zoho invoice ID
    if (!zohoInvoiceId || zohoInvoiceId.trim() === "") {
      throw new Error("Zoho invoice ID is required");
    }

    // Execute repository call
    return await this.repository.getZohoInvoiceDetails(zohoInvoiceId.trim());
  }
}

